import { GlobalStorage } from '@feedyou/schema'
import botFlowJsonSchema from '@feedyou/schema/schema/botFlow.json'
import produce from 'immer'
import _ from 'lodash'
import { FormData } from './utils'

const baseSchema = botFlowJsonSchema.properties.globalStorages.additionalProperties

export function getSchema(value: FormData) {
  function getFieldTypeForTypeValue(
    val: FormData['type']
  ): 'object' | 'string' | 'number' | 'array' | 'boolean' {
    if (val === 'object') return 'string'
    if (val === 'array') return 'string' // EditorJsonWidget
    if (val === 'string') return 'string' // EditorJsonWidget
    if (val === 'number') return 'number'
    if (val === 'boolean') return 'boolean'
    return 'string'
  }

  return produce(baseSchema, draft => {
    // @ts-ignore
    draft.properties.value = { type: getFieldTypeForTypeValue(value.type) }
  })
}

export function getUiSchema(valueType: GlobalStorage['type'], environmentName: string) {
  function getWidget(type: GlobalStorage['type']) {
    switch (type) {
      case 'object':
      case 'array':
        return 'EditorJsonWidget'
      case 'string':
        return 'textarea'
      case 'number':
      default:
        return undefined
    }
  }

  return {
    name: { 'ui:title': 'Name' },
    value: {
      'ui:title': 'Value',
      'ui:classNames': 'checkbox-no-description',
      'ui:widget': getWidget(valueType)
    },
    type: {
      'ui:title': 'Type',
      'ui:widget': 'radio',
      'ui:classNames': 'rjsf-horizontal-radio-group'
    },
    environmentSpecific: {
      'ui:title': `${_.capitalize(environmentName)} only`,
      'ui:description':
        'When checked, storage will not be copied when moving version between environments (from production to test or test to production)'
    },
    readonly: {
      'ui:title': 'Read only',
      'ui:description': 'When read only, the storage value cannot be modified in tree'
    }
  }
}
